import React, { useState, useRef } from 'react';
import { View, Text, TextInput } from 'react-native';
import i18n from 'i18n-js';
import WheelPicker from 'react-native-wheel-pick';

import { scale } from '@components/frame';
import { isPhone, isWeb, isAndroid } from '@helpers';
import { font } from '@styles/fonts';

import ColorsWrapper from '@styles/colors';
import { webTimeCalculation } from '@services/webTimeCalculation';
import { isIOS } from '@helpers';

const TP = ({ C, onChange, onPress, value, isTwoLine, lableWidth, baseHeight, isLable, isOffset = true }) => {
  const formatNumber = (n) => (Number(n) < 10 ? `0${Number(n)}` : Number(n));
  const input = useRef(null);
  const isValue = Number(value.h) + Number(value.m) + Number(value.s) > 0;
  const [enteredValue, setEnteredValue] = useState(isValue ? `${formatNumber(value.h)}:${formatNumber(value.m)}:${formatNumber(value.s)}` : '');
  if (isWeb) {
    return (
      <TextInput
        ref={input}
        style={[
          {
            height: baseHeight,
            flex: 1,
            color: C('Label/Dark/Primary'),
            fontSize: scale(16),
            position: 'absolute',
            width: '100%',
            outline: 'none',
            border: 'none',
          },
          isWeb && { paddingRight: scale(15) },
          isTwoLine
            ? {
                paddingTop: scale(25),
                paddingLeft: scale(15),
              }
            : {
                paddingLeft: isLable ? lableWidth + scale(5) : scale(15),
              },
        ]}
        value={enteredValue}
        onChangeText={setEnteredValue}
        onBlur={() => {
          if (enteredValue === '') {
            return;
          }
          const seconds = webTimeCalculation(enteredValue);
          const h = Math.floor(seconds / 3600);
          const m = Math.floor((seconds - h * 3600) / 60);
          const s = seconds - h * 3600 - m * 60;
          onChange({ h, m, s });
          setEnteredValue(`${formatNumber(h)}:${formatNumber(m)}:${formatNumber(s)}`);
        }}
      />
    );
  }
  return <View style={[{ height: '100%', width: '100%', overflow: 'hidden' }]}>{<PickerControler {...{ C, onChange, isOffset, value }} />}</View>;
};

export const PickerControler = ({ C, onChange, value, isOffset }) => {
  const [selectedH, setSelectedH] = useState(Number(value.h));
  const [selectedM, setSelectedM] = useState(Number(value.m));
  const [selectedS, setSelectedS] = useState(Number(value.s));
  const item99 = Array.from({ length: 100 }, (_, i) => String(i));
  const item59 = Array.from({ length: 60 }, (_, i) => String(i));

  const w = 80;
  const offset = isAndroid ? 0 : 137;
  return (
    <View
      style={{
        width: '100%',
        height: '100%',
        shadowColor: '#000',
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,
        elevation: 4,
        overflow: 'hidden',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
      }}
    >
      <View
        style={{
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
          flexDirection: 'row',
          height: '100%',
          marginLeft: isOffset ? scale(isPhone ? -16 : -60) : 0,
        }}
      >
        <View style={{ marginTop: -offset }}>
          <WheelPicker.Picker
            style={{ width: w, height: isIOS ? 80 : 200, backgroundColor: 'none' }}
            selectedValue={selectedM}
            itemStyle={{
              fontSize: 16,
            }}
            textSize={16}
            textColor={C('Label/Light/Primary')}
            onValueChange={(index) => {
              setSelectedH(index);
              onChange({ ...value, h: index });
            }}
            pickerData={item99.map((value, i) => {
              return { value: i, label: value };
            })}
          />
        </View>
        <View style={{ height: '100%', justifyContent: 'center', marginLeft: scale(6) }}>
          <Text style={[font['Body'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('h')}</Text>
        </View>
        <View style={{ marginTop: -offset, marginLeft: scale(12) }}>
          <WheelPicker.Picker
            style={{ width: w, height: isIOS ? 80 : 200, backgroundColor: 'none' }}
            selectedValue={selectedM}
            itemStyle={{
              fontSize: 16,
            }}
            textSize={16}
            textColor={C('Label/Light/Primary')}
            onValueChange={(index) => {
              setSelectedM(index);
              onChange({ ...value, m: index });
            }}
            pickerData={item59.map((value, i) => {
              return { value: i, label: value };
            })}
          />
        </View>
        <View style={{ height: '100%', justifyContent: 'center', marginLeft: scale(6) }}>
          <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('m')}</Text>
        </View>
        <View style={{ marginTop: -offset, marginLeft: scale(12) }}>
          <WheelPicker.Picker
            style={{ width: w, height: isIOS ? 80 : 200, backgroundColor: 'none' }}
            selectedValue={selectedS}
            itemStyle={{
              fontSize: 16,
            }}
            textSize={16}
            textColor={C('Label/Light/Primary')}
            onValueChange={(index) => {
              setSelectedS(index);
              onChange({ ...value, s: index });
            }}
            pickerData={item59.map((value, i) => {
              return { value: i, label: value };
            })}
          />
        </View>
        <View style={{ height: '100%', justifyContent: 'center', marginLeft: scale(6) }}>
          <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('s')}</Text>
        </View>
      </View>
    </View>
  );
};

export default ColorsWrapper(TP);
